<section id="dacAgenda-id" class="dac-agenda" *ngIf="(serviceList$ | async)?.length">
  <div class="box">
    <div class="box-content">
      <div class="box-content__title"
        ><span>{{ 'EVENT.DIGITAL_ACCOUNTING_CONFERENCE.AGENDA.TITLE' | translate }}</span></div
      >
      <div class="box-content__detail"
        ><span>{{ 'EVENT.DIGITAL_ACCOUNTING_CONFERENCE.AGENDA.DETAIL' | translate }}</span></div
      ></div
    >
    <div class="box-wrapper">
      <div class="box-wrapper__block">
        <div class="box-wrapper__block--list">
          <ng-container *ngFor="let item of serviceList$ | async; let last = last">
            <div class="list-item">
              <div class="list-item__time" [ngClass]="{ break: item.data.isBreak.iv }"
                ><span>{{ item.data.time.iv }}</span></div
              >

              <ng-container *ngIf="!item.data.isBreak.iv">
                <div class="list-item__content">
                  <div class="list-item__content--topic"
                    ><span>{{ item.data.topic.iv }}</span></div
                  >
                  <div class="list-item__content--speaker">
                    <ng-container *ngFor="let speaker of item.data.speakers.iv">
                      <div class="speaker-detail">
                        <img
                          *ngIf="speaker.image"
                          [src]="speaker.image"
                          class="speaker-detail__image"
                          loading="lazy"
                          [alt]="speaker.name"
                        />
                        <div class="speaker-detail__info">
                          <div *ngIf="speaker.name" class="speaker-detail__info--name"
                            ><span>{{ speaker.name }}</span></div
                          >
                          <div *ngIf="speaker.name" class="speaker-detail__info--position"
                            ><span>{{ speaker.position }}</span></div
                          >
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="item.data.isBreak.iv">
                <div class="list-item__break-full"
                  ><span>{{ item.data.time.iv }}</span> <span>{{ item.data.topic.iv }}</span></div
                >
              </ng-container>
            </div>
            <div *ngIf="!item.data.isBreak.iv && !last" class="list-underline"></div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</section>
